<template>
  <div class="container-fluid h-100">
    <div class="content-questions" id="content1-questions">
      <div class="py-3 row d-flex">
        <div style="margin:auto;" class="py-3 col-lg-4">
          <img title="Preguntas frecuentes Havoline MotoClub" class="img-title img-fluid" src="../../assets/img/preguntas.png" alt="Preguntas frecuentes Havoline MotoClub"/>
        </div>
        <div class="pt-5 col-lg-8">
          <h1 class="title-question pt-3 text-left">
            Preguntas frecuentes <br>Havoline MotoClub.
          </h1>
          <div class="div-questions py-3">
            <template v-for="data in list">
              <p class="title-questions">
                {{data.cont}}. {{data.title}}
              </p>
              <p class="text-questions">
                {{data.answer}}
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      list: [],
      loading: {
        activeList: false
      }
    };
  },

  methods: {
    getImg() {
      this.loading.activeList = true;
      this.defectList = [];
      axios
        .get("api/question/getActive")
        .then(res => {
          if (res.data.cod == 0) {
            this.list = res.data.data;
            var cont = 1;
            for (let i = 0; i < this.list.length; i++) {
              this.list[i].cont = cont++;
              
            }
          }
          this.loading.activeList = false;
        })
        .catch(error => {
          this.loading.activeList = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
  },
  mounted() {
    this.getImg();
  }
};
</script>

<style>
.p-t {
  padding-top: 4.7%;
}
.img-title {
  width: 450px;
  height: 415px;
  margin:auto;
}
.title-div {
  position: relative;
  display: inline-block;
  text-align: center;
  text-align: left;
  color: #dc3545;
}
.texto-encima {
  position: absolute;
  top: 10px;
  left: 35px;
}
.title-question-title {
  margin-top: 40% !important;
}
.title-question {
  /* font-size: 25px !important; */
  font-weight: bold;
  color: #dc3545;
}
.div-questions {
  height: 320px;
  overflow: scroll;
  text-align: left;
  padding-right: 10%;
}
.title-questions {
  color: #2380c1;
  font-weight: bold;
  margin: 0px 0px 0px;
}
.text-questions {
  color: #949494;
}

/* Estilos para motores Webkit y blink (Chrome, Safari, Opera... )*/
.div-questions::-webkit-scrollbar {
  -webkit-appearance: none;
}
.div-questions::-webkit-scrollbar:vertical {
  width: 10px;
}
.div-questions::-webkit-scrollbar-button:increment,
.div-questions::-webkit-scrollbar-button {
  display: none;
}
.div-questions::-webkit-scrollbar:horizontal {
  height: 10px;
}
.div-questions::-webkit-scrollbar-thumb {
  background-color: #797979;
  border-radius: 20px;
  border: 2px solid #f1f2f3;
}
.div-questions::-webkit-scrollbar-track {
  border-radius: 10px;
}
#content1-questions {
  background-color: #f0f0f0;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.card-content-text {
  background-color: #f5f5dc00;
  border: 0px;
}

@media (min-width: 2500px) {
  .title-question-title{
    margin-top: 20% !important;
  }
  .texto-encima {
    top: 30px;
  }
}

@media (max-width: 1264px) {
  .title-question-title{
    margin-top: 65% !important;
  }
  .texto-encima {
    top: 30px;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .title-question-title{
    margin-top: 8% !important;
  }
  .title-div {
    text-align: left;
    padding-top: 5%;
  }
  .title-link {
    text-align: left;
    border: 0px;
  }
  .btn-link-red {
    text-align: left;
  }
  .text-frecuent {
    padding-left: 15%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .title-question-title{
    margin-top: 20% !important;
  }
  .img-title {
    margin-left: -6%;
    background-position: center center;
    background-attachment: fixed;
    background-color: "#171717";
  }
  .texto-encima {
    top: 65px;
  }
}
</style>
